export enum SessionEnd {
  Inactivity = 'inactivity',
  Navigation = 'navigation',
  BrowserClose = 'browserClose',
  ReloadPage = 'reloadPage',
  Logout = 'logout',
}
